import React from "react";
import { Lending } from "../../components/Lending";


export const LendingBaboGardens = () => {
  return <div>
    <Lending title="Babo Gardens"/>
  </div>;
};
